import React from "react";
import { Link } from "react-router-dom";
import Bluedots from "../../assets/images/blue_dotes.png";

function Pricing() {
  return (
    <>
      <section
        id="pricing"
        className="row_am pricing_section white_text"
        data-aos="fade-in"
        data-aos-duration={1500}
      >
        <div className="pricing_inner">
          <div className="container">
            <div className="dotes_blue">
              <img src={Bluedots} alt="" />
            </div>
            <div
              className="section_title"
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={300}
            >
              <span className="title_badge">Abonnements</span>
              <h2>Choisis ton plan Neoori</h2>
            </div>

            <div className="pricing_pannel">
              <div className="row">
                <div className="col-md-4">
                  <div
                    className="pannel_block"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                  >
                    <div className="heading">
                      <h3>DÉCOUVERTE</h3>
                      <span>Pour explorer</span>
                    </div>
                    <div className="pricing">
                      <h2>0€</h2>
                      <p>Gratuit pour toujours</p>
                    </div>
                    <ul className="features">
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Test de personnalité essentiel</b>
                          <br />
                          <span className="feature-description">Découvre tes grandes tendances</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Coach IA</b> 3 q/jour
                          <br />
                          <span className="feature-description">Pour poser tes premières questions</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>1 recommandation de parcours</b>
                          <br />
                          <span className="feature-description">Pour commencer à explorer</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Mini-jeux de base & progression</b>
                          <br />
                          <span className="feature-description">Gamification introductive</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Rooms thématiques</b>
                          <br />
                          <span className="feature-description">Participation en lecture + échanges</span>
                        </p>
                      </li>
                      <li className="disabled">
                        <p>
                          <i className="icofont-close-circled"></i> Analyse de
                          CV
                        </p>
                      </li>
                      <li className="disabled">
                        <p>
                          <i className="icofont-close-circled"></i>{" "}
                          Recommandations personnalisées
                        </p>
                      </li>
                      <li className="disabled">
                        <p>
                          <i className="icofont-close-circled"></i> Simulateur
                          d'aménagements
                        </p>
                      </li>
                    </ul>
                    <div className="btn_block">
                      <Link to="/contact" className="btn puprple_btn ml-0">
                        Démarrer gratuitement
                      </Link>
                      <div className="btn_bottom" />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div
                    className="pannel_block highlited_block"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                  >
                    <div className="heading">
                      <h3>PLUS</h3>
                      <span>Pour progresser</span>
                    </div>
                    <div className="pricing">
                      <h2>9,90 €</h2>
                      <p>par mois</p>
                    </div>
                    <ul className="features">
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>5 tests scientifiques complets</b>
                          <br />
                          <span className="feature-description">Personnalité, valeurs, intelligences...</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Coach IA</b> 10 q/jour
                          <br />
                          <span className="feature-description">Accompagnement guidé au quotidien</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Analyse complète du CV</b>
                          <br />
                          <span className="feature-description">Forces, axes, suggestions</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Recommandations personnalisées</b>
                          <br />
                          <span className="feature-description">Métiers, formations, environnements</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Mini-jeux complets & progression</b>
                          <br />
                          <span className="feature-description">Parcours gamifié intégral</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Rooms thématiques</b>
                          <br />
                          <span className="feature-description">Participation active</span>
                        </p>
                      </li>
                      <li className="disabled">
                        <p>
                          <i className="icofont-close-circled"></i> Rooms
                          partenaires
                        </p>
                      </li>
                      <li className="disabled">
                        <p>
                          <i className="icofont-close-circled"></i> Simulateur
                          d'aménagements
                        </p>
                      </li>
                    </ul>
                    <div className="btn_block white_btn">
                      <Link to="/contact" className="btn puprple_btn ml-0">
                        Choisir ce plan
                      </Link>
                      <div className="btn_bottom" />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div
                    className="pannel_block"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                  >
                    <div className="heading">
                      <h3>PREMIUM</h3>
                      <span>Pour aller plus loin</span>
                    </div>
                    <div className="pricing">
                      <h2>14,90 €</h2>
                      <p>par mois</p>
                    </div>
                    <ul className="features">
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Tout le plan Plus inclus</b>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Coach IA</b> 20 q/jour
                          <br />
                          <span className="feature-description">Réponses prioritaires & cas complexes</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Simulateur d'aménagements</b>
                          <br />
                          <span className="feature-description">Conçu pour les profils neuroatypiques</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Plan d'évolution 6 mois</b>
                          <br />
                          <span className="feature-description">Feuille de route avec jalons</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Rooms partenaires</b>
                          <br />
                          <span className="feature-description">Entreprises, établissements, offres</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="icofont-check-circled"></i>{" "}
                          <b>Scénarios IA avancés</b>
                          <br />
                          <span className="feature-description">Exploration approfondie</span>
                        </p>
                      </li>
                    </ul>
                    <div className="btn_block">
                      <Link to="/contact" className="btn puprple_btn ml-0">
                        Passer au Premium
                      </Link>
                      <div className="btn_bottom" />
                    </div>
                  </div>
                </div>
              </div>
              <p
                className="contact_text text-center"
                data-aos="fade-up"
                data-aos-duration={1500}
              >
                Tu n'es pas sûr du bon plan ? <Link to="#">Contacte-nous</Link>{" "}
                pour une offre personnalisée.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Pricing;
